import React,{useState, useRef, Fragment} from "react";
import HoverButton from "../buttons/HoverButton";
import {ErrorMessage, Loader, TextareaField, ErrorTooltip} from "react-fields";
import PopUp from "../base/popup";
import {renderToStaticMarkup} from "react-dom/server";


export default function AccessCodeArea(props) {

    const copyTextareaRef = useRef(null);
    const successCopyToClipboard = useRef(null);

    const generateInviteText = () => {
        return "1) Create a CareerHunter account at https://www.careerhunter.io/register\n" +
            "2) Navigate to the Settings area (located in the menu)\n" +
            "3) Scroll to the bottom and click the 'Have an access code?' text link, and enter the code " + props.accessCode;
    };

    const copyToClipboard = (e) => {
        e.preventDefault();
        copyTextareaRef.current.select();
        console.log(copyTextareaRef.current);
        document.execCommand('copy');
        e.target.focus();
        successCopyToClipboard.current.open();
    };

    return (
        <Fragment>
            <div className="small-12 cell mar-top-30">
                <h3 className="licenses__title">Invite using your unique code</h3>
                <h3 className="licenses__num mar-bot-10">{props.accessCode}</h3>
                <p>Grant test-taker access by sharing the above code along with these instructions:</p>
                <div className={'vertical-resize licenses__emails licenses__emails--student'}>
                    <textarea ref={copyTextareaRef} value={generateInviteText()} readOnly={true} rows={4} />
                </div>
                <HoverButton onClick={copyToClipboard} className={'float-right'} color={'grey'}>Copy</HoverButton>
            </div>
            <PopUp ref={successCopyToClipboard}>
                <div className="grid-x align-center">
                    <div className="small-12 cell text-center">
                        <h3 className='mar-bot-10'>Invitation instructions copied to your clipboard</h3>
                    </div>
                    <div className="cell text-center  mar-top-10">
                        <HoverButton onClick={() => {successCopyToClipboard.current.close()}}>Close</HoverButton>
                    </div>
                </div>
            </PopUp>
            <div className="small-8 cell mar-top-30 mar-bot-20">
                <h3 className="licenses__title">Or invite by email</h3>
            </div>
        </Fragment>
    )

}